<template>
  <div class="yhc-component YhcAreaSelect" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>

    <div class="content">
      <el-select
        :disabled="onlyRead"
        class="select"
        clearable
        v-model="pageAddressData.province"
        placeholder="请选择省"
        @change="provinceChange"
      >
        <el-option
          v-for="(item, index) in provinceArr"
          :key="index"
          :label="item.value"
          :value="item"
        ></el-option>
      </el-select>
      <el-select
        :disabled="onlyRead"
        class="select"
        clearable
        v-model="pageAddressData.city"
        placeholder="请选择市"
        @change="cityChange"
      >
        <el-option
          v-for="(item, index) in cityArr"
          :key="index"
          :label="item.value"
          :value="item"
        ></el-option>
      </el-select>
      <el-select
        :disabled="onlyRead"
        class="select"
        v-if="!hiddenArea"
        clearable
        v-model="pageAddressData.district"
        placeholder="请选择区"
        @change="districtChange"
      >
        <el-option
          v-for="(item, index) in districtArr"
          :label="item.value"
          :key="index"
          :value="item"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import allArea from './componentsData/address';

import propsMixin from './componentsData/propsMixin';
import PrivateLabel from './componentsData/PrivateLabel.vue';

let identifierName = 'YhcAreaSelect';
export default {
  name: identifierName,
  components: { PrivateLabel },
  mixins: [propsMixin],
  data() {
    return {
      provinceArr: [],
      cityArr: [],
      districtArr: [],
      pageAddressData: {
        province: '',
        city: '',
        district: '',
      },
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    hiddenArea: {
      type: Boolean,
      default: false,
    },
    // 有时候获取不到值，则用这个处理，加个延迟即可，一般500ms可以了
    delayGetData: {
      type: [Number, String],
      default: 0,
    },
  },
  watch: {
    value: {
      handler: function () {
        this.getArea();
      },
      deep: true,
    },
  },
  methods: {
    getArea() {
      let provinceArr = [];

      for (let index = 0; index < allArea.length; index++) {
        const element = allArea[index];
        if (element.type == '省') {
          provinceArr.push({
            name: element.name,
            value: element.name,
            id: element.id,
          });
        }
      }

      this.provinceArr = provinceArr;
      let { province, city, district } = this.value;

      let provinceId = undefined;
      let cityId = undefined;
      let districtId = undefined;
      if (province) {
        cityId = allArea.find((v) => v.name == province).id;
        this.pageAddressData.province = province;
      }
      if (city) {
        districtId = allArea.find((v) => v.name == city).id;
        this.pageAddressData.city = city;
      }
      if (district) {
        this.pageAddressData.district = district;
      }
      this.updateCity(cityId);
      this.updateDistrict(districtId);
    },
    provinceChange(e) {
      // if (!e) {
      //   this.cityArr = [];
      //   this.districtArr = [];
      //   this.pageAddressData.city = "";
      //   this.pageAddressData.district = "";
      // } else {
      //   this.updateCity(e.id);
      // }

      this.cityArr = [];
      this.districtArr = [];
      this.pageAddressData.city = '';
      this.pageAddressData.district = '';
      this.updateCity(e.id);
      this.handleChange();
    },
    cityChange(e) {
      // if (!e) {
      //   this.districtArr = [];
      //   this.pageAddressData.district = "";
      // } else {
      //   this.updateDistrict(e.id);
      // }
      this.districtArr = [];
      this.pageAddressData.district = '';
      this.updateDistrict(e.id);
      this.handleChange();
    },
    districtChange() {
      this.handleChange();
      // this.cityArr = city
    },
    updateCity(parentId) {
      let city = [];
      for (let index = 0; index < allArea.length; index++) {
        const element = allArea[index];
        if (element.type == '市' && element.parentId == parentId) {
          city.push({
            name: element.name,
            value: element.name,
            id: element.id,
          });
        }
      }
      this.cityArr = city;
    },
    updateDistrict(parentId) {
      let district = [];
      for (let index = 0; index < allArea.length; index++) {
        const element = allArea[index];
        if (element.type == '区' && element.parentId == parentId) {
          district.push({
            name: element.name,
            value: element.name,
            id: element.id,
          });
        }
      }
      this.districtArr = district;
    },
    handleChange() {
      let currData = {};
      for (const key in this.pageAddressData) {
        if (this.pageAddressData.hasOwnProperty(key)) {
          currData[key] = this.pageAddressData[key].value || this.pageAddressData[key] || '';
        }
      }
      this.$nextTick(() => {
        this.$emit('change', currData);
        this.$emit('input', currData);
      });
    },
  },
  mounted() {
    if (this.delayGetData * 1) {
      setTimeout(() => {
        this.getArea();
      }, this.delayGetData * 1);
    }
  },
  created() {
    this.getArea();
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcAreaSelect {
  @include labelCommon();
  .select {
    margin-right: 16px;
  }

  @media screen and (max-width: 700px) {
    .select {
      margin-right: 0;
      margin-bottom: 8px;
      width: 100%;
    }
  }
}
</style>
